<div class="content">

    <div class="text-left mt-5">


        <h3>Get Image Batch details</h3> <br><br>

        <p>Get batch details</p><br><br>

        <p class="text-muted">PATH PARAMETERS</p>
        <hr><br>

        <div class="table-responsive">
            <table class="table table-primary table-bordered">
                <tbody>

                    <tr>
                        <td>
                            <h6>id [required]</h6>
                        </td>
                        <td colspan="4">
                            <small>string^[-a-z0-9_]+$</small><br>

                            <p>
                                The batch id of the batch to fetch
                            </p>
                        </td>
                    </tr>


                </tbody>
            </table>
        </div><br>


        <div class="card text-bg-dark mb-3">
            <div class="card-body">
              <pre><button type="button" class="btn btn-success">GET</button>  https://api.optimusdrive.ai/image/v1/batch/&lt;id&gt;</pre>
            </div>
          </div> <br><br>

        <h5>Example Request</h5><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">

                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm"
                        (click)="copyJsonToClipboard()">
                        <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>

                    <button style="float: right;" *ngIf="copiedButton" class="btn btn-success btn-sm">
                        Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>

                </div><br><br>

                <pre><code [innerHTML]="requestData"></code></pre>
            </div>
        </div><br><br>


        <div>

            <h5>Example Response</h5><br>


            <div class="card text-bg-light mb-3">
                <div class="card-body">

                    <div class="panel panel-primary">
                        <div class="tab-menu-heading">
                            <ul class="nav nav-pills" role="tablist">
                                <!-- Tab menu items -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="tab1" data-bs-toggle="tab"
                                        data-bs-target="#content1" type="button" role="tab" aria-controls="content1"
                                        aria-selected="true">200</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#content2"
                                        type="button" role="tab" aria-controls="content2"
                                        aria-selected="false">401</button>
                                </li>

                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#content3" type="button"
                                      role="tab" aria-controls="content2" aria-selected="false">502</button>
                                </li>
                                
                            </ul>
                        </div>

                        <div class="panel-body tabs-menu-body mt-4">
                            <div class="tab-content">
                                <!-- Tab content -->
                                <div class="tab-pane fade show active" id="content1" role="tabpanel"
                                    aria-labelledby="tab1">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="sucessData" ></code></pre>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="content2" role="tabpanel" aria-labelledby="tab2">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="Error401x" ></code></pre>
                                    </div>
                                </div>

                                <div class="tab-pane fade" id="content3" role="tabpanel" aria-labelledby="tab3">
                                    <div class="card-body">
                                      <pre><code [innerHTML]="Error502" ></code></pre>
                                    </div>
                                  </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>


        </div><br><br><br>











    </div>

</div>